//export const WALLET_CONNECT_PROJECT_ID = '3f930f8e56336b44761655d8a270144c';
export const WALLET_CONNECT_PROJECT_ID = '';
export const CHAIN_ID_SEARCH_PARAM = 'chainId';
